exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".drug[data-v-26b326d2]{padding:15px;background-color:#fbf9f9;border-radius:3px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:inherit;justify-content:inherit;margin-top:15px}.drug h5[data-v-26b326d2]{margin:0 0 5px}.drug .img[data-v-26b326d2]{height:70px;width:80px;overflow:hidden;margin-right:20px;border-radius:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26b326d2","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/drug.vue
// module id = 166
// module chunks = 1